// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1VK7p","fira-sans":"Footer_fira-sans__2H3CT"};